__webpack_require__.p = "/KruskalAlgoVisualizer/";